<template>
  <v-app id="inspire">
    <div>
      <v-layout class="mb-4">
        <v-flex>
          <h2 class="headline">Payouts</h2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          class="ma-0"
          text
          small
          @click="downloadCSV"
          :loading="loadingCSV"
          :disabled="loadingCSV"
          ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
        >
      </v-layout>
      <payment-processor-alert v-if="paymentProcessor === 'stripe'"></payment-processor-alert>
      <v-flex class="header-search-single">
        <v-layout>
          <v-flex xs6 class="inv-wrap-search">
            <v-text-field
              class="inv-search-field"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              @input="typing = true"
            >
            </v-text-field>
          </v-flex>
          <v-layout xs6>
            <v-btn
              v-if="!showFilters"
              text
              class="mt-4 mx-2 px-2 dialog-btn"
              @click="showFilters = !showFilters"
            >
              <v-icon class="mr-2">filter_list</v-icon>
              <span style="text-transform: none; color: #00838F"
                >Show Filters</span
              ></v-btn
            >
            <template v-else>
              <v-btn
                text
                class="mt-4 mx-2 px-2 dialog-btn"
                @click="showFilters = !showFilters"
              >
                <v-icon class="mr-2">filter_list</v-icon>
                <span style="text-transform: none; color: #00838F;"
                  >Hide Filters</span
                ></v-btn
              >
            </template>
          </v-layout>
        </v-layout>
        <v-layout class="wrap">
          <v-container
            container--fluid
            v-if="showFilters"
            class="grid-list-md pa-0 mb-4 xs12"
          >
            <v-layout class="mt-2 xs12 wrap">
              <v-flex class="xs12 sm6 md2" style="min-width: 170px;">
                <v-select
                  :items="statuses"
                  v-model="selectedStatuses"
                  label="Status"
                  multiple
                  placeholder="Please Select"
                >
                  <template slot="selection" slot-scope="{ item, index }">
                    <span class="mr-1" v-if="index === 0">{{ item }}</span>
                    <span v-if="index === 1" class="grey--text caption"
                      >(+{{ selectedStatuses.length - 1 }} others)</span
                    >
                  </template>
                </v-select>
              </v-flex>
              <v-flex class="xs12 sm6 md2">
                <v-menu
                  ref="menu1"
                  :label="`From Date`"
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="tableData.from"
                      :label="`From Date`"
                      placeholder="Please Select"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tableData.from"
                    no-title
                    @input="menu1 = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex class="xs12 sm6 md2">
                <v-menu
                  ref="menu2"
                  :label="`To Date`"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-on="on"
                      v-model="tableData.to"
                      :label="`End Date`"
                      placeholder="Please Select"
                      persistent-hint
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="tableData.to"
                    no-title
                    @input="menu2 = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex class="xs12">
                <v-btn
                  large
                  color="primary" 
                  class="mx-0 mt-1 mb-2"
                  style="min-width: 50px; padding: 0 10px;"
                  @click="go"
                >Go</v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="showFilters" class="xs12">
              <v-flex d-flex style="max-width: 100px;">
                <span class="mt-0 ml-0 clear-filters" @click="clearFilters"
                  >Clear Filters</span
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-flex>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20, 50]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td :class="`payouts-type-${item.status}`">
                <div class="payouts-status-text" style="display: inline-block">
                  <span>{{ upperFirst(item.status) }}</span>
                </div>
              </td>
              <td>{{ item.date }}</td>
              <td>{{ item.arrival_date }}</td>
              <td>{{ `$${parseFloat(item.amount).toFixed(2)}` }}</td>
              <td>{{ `$${parseFloat(item.tip_amount).toFixed(2)}` }}</td>
              <td>{{ item.count_items }}</td>
              <td>
                <v-flex style="min-width: 60px;">
                  <v-flex
                    class="pr-2 action-link"
                    @click="goToPayoutView(item.id)"
                    >View
                    <v-icon>visibility</v-icon>
                  </v-flex>
                </v-flex>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>
<script>
import ApiService from "@/common/api.service";
import { mapActions, mapGetters } from 'vuex'
import PaymentProcessorAlert from "../PaymentProcessorAlert/PaymentProcessorAlert"

export default {
  name: "Payouts",
  components: {
    PaymentProcessorAlert
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    statuses: ["Success", "Failed"],
    menu1: false,
    menu2: false,
    selectedStatuses: ["Success", "Failed"],
    showFilters: false,
    totalItems: 0,
    items: [],
    loading: false,
    options: {},
    valid: true,
    search: "",
    headers: [
      { text: "Status", value: "status", sortable: false },
      { text: "Date Created", value: "date", sortable: false },
      { text: "Arrival Date", value: "arrival_date", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Tip", value: "tip_amount", sortable: false },
      { text: "Items", value: "count_items", sortable: false },
      { text: "Actions", sortable: false }
    ],
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 1,
      dir: "desc"
    },
    form_model: true,
    loadingCSV: false,
    payoutShowDialog: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize()
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1
        this.initialize()
      }
    }, 1000)
  },
  mounted() {
    this.initialize();
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 1;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;
      this.tableData.page = page;
      this.tableData.search = this.search;

      this.tableData.statuses = this.selectedStatuses.map(i => _.snakeCase(i));

      this.tableData.draw++;
      this.draw = this.tableData.draw;

      ApiService.get("/payouts", this.tableData).then(response => {
        this.draw++
        this.items = response.data.payouts.data;
        this.totalItems = response.data.payouts.total;
        this.loading = false;
      });
    },
    go() {
      this.options.page = 1
      this.initialize();
    },
    clearFilters() {
      this.selectedStatuses = this.statuses;
      delete this.tableData.from;
      delete this.tableData.to;
      this.options.page = 1
      this.initialize();
    },
    downloadCSV() {
      this.loadingCSV = true;
      this.tableData.statuses = this.selectedStatuses.map(i => _.snakeCase(i));
      let body = _.pick(this.tableData, [
        "statuses",
        "from",
        "to",
        "column",
        "dir",
        "search"
      ]);
      ApiService.get("/payouts/export", body)
        .then(response => {
          // console.log(response.data.payouts)
          let items = response.data.payouts;
          let csvContent = "";
          let headers =
            '"Payout ID","Status","Date Created","Arrival Date","Payout Amount","Amount","Fee","Net","Tip","Customer Full Name","Customer Email","Invoice No."\n';
          let csvData = [];
          items.forEach(i => {
            let row = {
              id: `"${
                !this.no_data.includes(i.payout_id) ? i.payout_id : "No data"
              }"`,
              status: `"${
                !this.no_data.includes(i.status) ? i.status : "No data"
              }"`,
              date: `"${!this.no_data.includes(i.date) ? i.date : "No data"}"`,
              arrival_date: `"${
                !this.no_data.includes(i.arrival_date)
                  ? i.arrival_date
                  : "No data"
              }"`,
              amount_payout: `"${
                !this.no_data.includes(i.amount_payout)
                  ? parseFloat(i.amount_payout).toFixed(2)
                  : "No data"
              }"`,
              amount: `"${
                !this.no_data.includes(i.amount)
                  ? parseFloat(i.amount).toFixed(2)
                  : "No data"
              }"`,
              fee: `"${
                !this.no_data.includes(i.fee)
                  ? parseFloat(i.fee).toFixed(2)
                  : "No data"
              }"`,
              net: `"${
                !this.no_data.includes(i.net)
                  ? parseFloat(i.net).toFixed(2)
                  : "No data"
              }"`,
              tip: `"${
                !this.no_data.includes(i.tip_amount)
                  ? parseFloat(i.tip_amount).toFixed(2)
                  : "No data"
              }"`,
              customer_name: `"${
                !this.no_data.includes(i.customer_name)
                  ? i.customer_name
                  : "No data"
              }"`,
              customer_mail: `"${
                !this.no_data.includes(i.customer_mail)
                  ? i.customer_mail
                  : "No data"
              }"`,
              invoice_no: `"${
                !this.no_data.includes(i.invoice_no) ? i.invoice_no : "No data"
              }"`
            };
            csvData.push(row);
          });

          csvContent += headers;
          csvContent += csvData
            .map(item => Object.values(item).join(","))
            .join("\n");
          csvContent = csvContent.replace(/(^\[)|(\]$)/gm, "");

          const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(data)
          const link = document.createElement("a");
          link.setAttribute("href", url);
          link.setAttribute("download", "Payouts.csv");
          link.click();

          this.loadingCSV = false;
        })
        .catch(error => {
          console.log(error);
          this.loadingCSV = false;
          this.vEmit({ name: "notification", 
            data: {
              status: "error",
              text: "Oops something went wrong..."
            }
          });
        });
    },

    goToPayoutView(id) {
      this.$router.push(`/payout/${id}/show`);
    },

    resetServerValidation() {
      this.serverValidation = true;
      this.serverValidationMessage = "Oops something went wrong...";
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    },
    upperFirst(str) {
      return _.upperFirst(str);
    }
  },
  computed: {
    ...mapGetters(['paymentProcessor'])
  }
};
</script>
<style>
/*New Coupon Dialog*/
.wrap-dialog-elements {
  width: 100%;
  float: left;
}

.date-picker-dialog {
  margin-bottom: 20px;
}
.payouts-type-failed {
  color: red;
}

.payouts-type-success {
  color: forestgreen;
}

.payouts-status-text {
  text-transform: uppercase;
}
.payouts-status-text span {
  padding: 5px;
  font-size: 13px;
}
.clear-filters {
  text-transform: none;
  color: #00838F;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
}
</style>
